limitNotesHeight();

// limit notes height
function limitNotesHeight() {
  const notes = document.querySelector(".av-rom-notater .vrtx-box-content");

  if (notes.offsetHeight < notes.scrollHeight) {
    notes.classList.add("has-overflow");

    // create and add show-more button
    const showMoreButton = document.createElement("button");
    const buttonTextAll = "Vis alle notater";
    const buttonTextLess = "Vis mindre";
    showMoreButton.textContent = buttonTextAll;
    showMoreButton.classList.add("show-more");
    notes.after(showMoreButton);

    // show-more button click
    showMoreButton.addEventListener("click", function() {
      if (notes.classList.contains("expanded")) {
        notes.classList.remove("expanded");
        showMoreButton.textContent = buttonTextAll;
      }
      else {
        notes.classList.add("expanded");
        showMoreButton.textContent = buttonTextLess;
      }
    });
  }
}
